import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import * as moment from 'moment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ExportToCsv } from 'export-to-csv';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { LoyaltyService } from 'src/app/modules/retailer/services/loyalty.service';

interface IRange {
  value: Date[];
  label: string;
}

@Component({
  selector: 'app-loyalty-home',
  templateUrl: './loyalty-home.component.html',
  styleUrls: ['./loyalty-home.component.scss']
})
export class LoyaltyHomeComponent implements OnInit {

  public loginData: any;

  public loyaltyCustomerCountData: any;
  public loyaltyCustomerCountDataLoading: boolean = false;
  public loyaltyCustomerSalesData: any;
  public loyaltyCustomerSalesDataLoading: boolean = false;
  public loyaltyTemplates: any;
  public loyaltyTemplatesLoading: boolean = false;
 
  public detailedReportModalData: any;
  public detailedReportModal: BsModalRef;

  public calendarRanges: IRange[];
  public calendarConfig;
  public calendarMinDate: Date;
  public calendarMaxDate: Date;
  public dateRange: any = [];

  constructor(
    private _router: Router,
    private _modalService: BsModalService,
    private _utilService: UtilService,
    private _loyaltyService: LoyaltyService
  ) {}

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    this.getLoyaltyCustomerCountData(false);
    this.getLoyaltyCustomerSalesData(false);
  }

  // Get loyalty customer count data
  getLoyaltyCustomerCountData(detailedReport: boolean) {
    let startDate: any = moment().subtract(30, 'days').format('YYYY-MM-DD'); // Today - 30
    let endDate: any = moment().format('YYYY-MM-DD'); // Today

    this.loyaltyCustomerCountDataLoading = true;

    if (detailedReport == false) { // Reset data
      this.loyaltyCustomerCountData = {
        total: 0,
        daysTotal: 0
      }
    } else { // Set report date to calendar date
      startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
      endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');
    }

    this._loyaltyService.getLoyaltyCustomerCount(this.loginData.token, this.loginData.user_details.provider_id, startDate, endDate).subscribe(async getLoyaltyCustomerCountResponse => {
      this.loyaltyCustomerCountDataLoading = false;
      
      if (getLoyaltyCustomerCountResponse.status === true) { // Success
        if (detailedReport == false) { // Set basic report data
          this.loyaltyCustomerCountData = {
            total: getLoyaltyCustomerCountResponse.total_customers,
            daysTotal: _.sumBy(getLoyaltyCustomerCountResponse.customers, 'count')
          }
        } else { // Set chart report data
          let chartlabels = [];
          let chartData = [];

          for (let i=0; i<=getLoyaltyCustomerCountResponse.customers.length-1; i++) {
            chartlabels.push(moment(getLoyaltyCustomerCountResponse.customers[i].date).format('MMM D'))
            chartData.push(getLoyaltyCustomerCountResponse.customers[i].count)
          }

          // Update chart data
          this.detailedReportModalData.chartData= {
            labels: chartlabels,
            datasets: [
              { label: 'Loyalty customers count', fill: true, tension: 0.5, pointStyle: 'circle', pointRadius: 5, pointHoverRadius: 10, pointBackgroundColor: environment.default_chart_color, borderColor: environment.default_chart_color, backgroundColor: environment.default_chart_area_color, data: chartData }
            ]
          }

          // Update export data
          this.detailedReportModalData.exportData = getLoyaltyCustomerCountResponse.customers;
        }
      } else {
        this._utilService.showToast(getLoyaltyCustomerCountResponse.message, '', 'error', {});
      }
    }, error => { // Error from getLoyaltyCustomerCount
      this.loyaltyCustomerCountDataLoading = false;
    });
  }

  // Get loyalty customer sales data
  getLoyaltyCustomerSalesData(detailedReport: boolean) {
    let startDate: any = moment().subtract(30, 'days').format('YYYY-MM-DD'); // Today - 30
    let endDate: any = moment().format('YYYY-MM-DD'); // Today

    this.loyaltyCustomerSalesDataLoading = true;

    if (detailedReport == false) { // Reset data
      this.loyaltyCustomerSalesData = {
        total: 0,
        daysTotal: 0
      }
    } else { // Set report date to calendar date
      startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
      endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');
    }

    this._loyaltyService.getLoyaltyCustomerSales(this.loginData.token, this.loginData.user_details.provider_id, startDate, endDate).subscribe(async getLoyaltyCustomerSalesResponse => {
      this.loyaltyCustomerSalesDataLoading = false;
      
      if (getLoyaltyCustomerSalesResponse.status === true) { // Success
        if (detailedReport == false) { // Set basic report data
          this.loyaltyCustomerSalesData = {
            total: getLoyaltyCustomerSalesResponse.total_sales,
            daysTotal: _.sumBy(getLoyaltyCustomerSalesResponse.sales, 'amount')
          }
        } else { // Set chart report data
          let chartlabels = [];
          let chartData = [];

          for (let i=0; i<=getLoyaltyCustomerSalesResponse.sales.length-1; i++) {
            chartlabels.push(moment(getLoyaltyCustomerSalesResponse.sales[i].date).format('MMM D'))
            chartData.push(getLoyaltyCustomerSalesResponse.sales[i].amount)
          }

          // Update chart data
          this.detailedReportModalData.chartData= {
            labels: chartlabels,
            datasets: [
              { label: 'Loyalty customers sales', fill: true, tension: 0.5, pointStyle: 'circle', pointRadius: 5, pointHoverRadius: 10, pointBackgroundColor: environment.default_chart_color, borderColor: environment.default_chart_color, backgroundColor: environment.default_chart_area_color, data: chartData }
            ]
          }

          // Update export data
          this.detailedReportModalData.exportData = getLoyaltyCustomerSalesResponse.sales;
        }
      } else {
        this._utilService.showToast(getLoyaltyCustomerSalesResponse.message, '', 'error', {});
      }
    }, error => { // Error from getLoyaltyCustomerCount
      this.loyaltyCustomerSalesDataLoading = false;
    });
  }

  // Open detailed report modal
  showDetailedReportModal(mode: string, template: TemplateRef<any>) {
    // Calendar setings with timezone
    this.calendarRanges = [
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 0)), new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 0))],  label: 'Today'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 1)), new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 1))],  label: 'Yesterday'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 6)), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))],  label: 'Last 7 Days'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 29)), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))],  label: 'Last 30 Days'},
    ];

    this.calendarConfig = { adaptivePosition: true, dateInputFormat: 'YYYY-MM-DD HH:mm', containerClass: 'theme-blue', showWeekNumbers: false, ranges: this.calendarRanges };
    this.calendarMinDate = new Date(moment().utcOffset(this.loginData.user_details.user_timezone).subtract(3, 'years').format('YYYY-MM-DD HH:mm'));
    this.calendarMaxDate = new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'));
    this.dateRange = [new Date(moment().subtract(30, 'days').utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))];
    
    if (mode == 'customer-count') { // Customer count report
      this.detailedReportModalData = {
        mode: mode,
        title: 'Loyalty Customers Report',
        chartHeight: 200,
        showYAxisDollarValue: false,
        chartData: null,
        exportData: []
      };
    } else { // Customer sales report
      this.detailedReportModalData = {
        mode: mode,
        title: 'Loyalty Sales Report',
        chartHeight: 200,
        showYAxisDollarValue: true,
        chartData: null,
        exportData: []
      };
    }

    this.detailedReportModal = this._modalService.show(template, {class: 'modal-lg'});
  }

  // On calendar value change
  onCalendarValueChange(event: any) {
    this.dateRange = event;

    if (this.detailedReportModalData.mode == 'customer-count') { // Customer count report
      this.getLoyaltyCustomerCountData(true);
    } else { // Customer sales report
      this.getLoyaltyCustomerSalesData(true);
    }
  }

  // Hide circular preview modal
  hideDetailedReportModal(): void {
    this.detailedReportModal.hide();
  }

  // Export date to csv
  exportData(mode: string) {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: false,
      useKeysAsHeaders: true,
      filename: mode
    };
    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(this.detailedReportModalData.exportData);
  }

}
